// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_fragment_property_propertyLocation(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["PropertyLocationWithHiddenAddress"]);
}

var fragmentConverter = {"__root":{"property_propertyLocation":{"u":"fragment_property_propertyLocation"}}};

var fragmentConverterMap = {
  fragment_property_propertyLocation: unwrap_fragment_property_propertyLocation
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function rentalPropertyMatchingType_decode($$enum) {
  if ($$enum === "BROADCAST") {
    return $$enum;
  }
  
}

function rentalPropertyMatchingType_fromString(str) {
  return rentalPropertyMatchingType_decode(str);
}

var Utils = {
  rentalPropertyMatchingType_decode: rentalPropertyMatchingType_decode,
  rentalPropertyMatchingType_fromString: rentalPropertyMatchingType_fromString
};

var node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MyClientsWidgetLandlord_name_landlord",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": "RentalPropertyV5",
        "kind": "LinkedField",
        "name": "property",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "propertyLocation",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v0/*: any*/)
                ],
                "type": "PropertyLocationWithHiddenAddress",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "RequiredField",
            "field": {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "matchingType",
              "storageKey": null
            },
            "action": "THROW"
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    }
  ],
  "type": "Landlord",
  "abstractKey": null
};
})());

var wrap_fragment_property_propertyLocation = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_property_propertyLocation = unwrap_fragment_property_propertyLocation;
exports.wrap_fragment_property_propertyLocation = wrap_fragment_property_propertyLocation;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
